export const steps = [
    {
        number: 1,
        title: "INVOICINGFORINDIVIDUALS_STEP_1_TITLE",
        text: "INVOICINGFORINDIVIDUALS_STEP_1_TEXT",
    },
    {
        number: 2,
        title: "INVOICINGFORINDIVIDUALS_STEP_2_TITLE",
        text: "INVOICINGFORINDIVIDUALS_STEP_2_TEXT",
    },
    {
        number: 3,
        title: "INVOICINGFORINDIVIDUALS_STEP_3_TITLE",
        text: "INVOICINGFORINDIVIDUALS_STEP_3_TEXT",
    },
    {
        number: 4,
        title: "INVOICINGFORINDIVIDUALS_STEP_4_TITLE",
        text: "INVOICINGFORINDIVIDUALS_STEP_4_TEXT",
    },
];